import React from 'react';
import styled from 'styled-components';
import { blue6 } from '../../../shared/colours';
import { UiTextMediumS } from '../../../shared/typography';
import { EmailRecipient } from './ShareNotesModal';

const Container = styled.div`
  cursor: pointer;
`;

const Label = styled(UiTextMediumS)`
  color: ${blue6};
`;

export interface AddRemoveProps {
  emailRecipients: EmailRecipient[],
  handleAddAllEmails: () => void,
  handleRemoveEmails: () => void,
}

const AddRemoveEmailsButton = ({
  emailRecipients,
  handleAddAllEmails,
  handleRemoveEmails,
}: AddRemoveProps) => {
  const isEmailsInputEmpty = emailRecipients.length === 0;
  if (isEmailsInputEmpty) {
    return (
      <Container onClick={handleAddAllEmails}>
        <Label>Add all recipients</Label>
      </Container>
    );
  }
  return (
    <Container onClick={handleRemoveEmails}>
      <Label>Remove all</Label>
    </Container>
  );
};

export default AddRemoveEmailsButton;
